import {defineStore} from "pinia";
import router from "@/router/index.js";
import {getAuthenticatedRequest} from "@/stores/AuthenticatedRequest.js";
import {useUserStore} from '@/stores/user.js';
import {useApi} from "@/services/useApi.js";
import {client} from '@/stores/client.js'

export const useBoostPaymentStore2 = defineStore('boostPayment2', {
  state: () => ({
    boostOrders: [],
    isFetching: false,
    isLoading: true,
    isImmediateRequest: false,
    currencies: [],
    filters: {
      'finalized': false,
      'stores': [],
      'games': [],
      'states': ['Delivered'],
      'createdFrom': null,
      'createdTo': null,
      'updatedFrom': null,
      'updatedTo': null,
      'lastUpdate': null
    },
  }),
  getters: {
    minimizedFilters(state) {
      return Object.fromEntries(
        Object.entries(state.filters).filter(([key, value]) => {
          if (Array.isArray(value)) return value.length > 0;
          return value !== null;
        })
      )
    },
    isFilterActive(state) {
      const f = state.filters;
      return (
        (f.stores && f.stores.length > 0) ||
        (f.games && f.games.length > 0) ||
        (f.states && f.states.length > 0) ||
        (state.currencies && state.currencies.length > 0) ||
        f.createdFrom !== null ||
        f.createdTo !== null ||
        f.updatedFrom !== null ||
        f.updatedTo !== null
      );
    },
    activeFilterCount(state) {
      const f = state.filters;
      let count = 0;

      if (f.stores.length > 0) count++;
      if (f.games.length > 0) count++;
      if (f.states.length > 0) count++;
      if (state.currencies.length > 0) count++;
      if (f.createdFrom !== null) count++;
      if (f.createdTo !== null) count++;
      if (f.updatedFrom !== null) count++;
      if (f.updatedTo !== null) count++;

      return count;
    },
  },
  actions: {
    async action_getSubOrders() {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 10092,
        "boostOrder": this.minimizedFilters,
      };
      if (this.isImmediateRequest) {
        this.boostOrders = []
        this.isImmediateRequest = false
      }
      if (this.isFetching === false) {
        try {
          this.isFetching = true
          await useApi(
            request,
            (response) => {
              const newOrders = response.data.boostOrders || []
              if (this.boostOrders.length === 0) {
                this.boostOrders = newOrders;
              } else {
                newOrders.forEach(newOrder => {
                  const index = this.boostOrders.findIndex(
                    o => o.uuid === newOrder.uuid || o.id === newOrder.id
                  );
                  if (index !== -1) {
                    this.boostOrders[index] = newOrder;
                  } else {
                    this.boostOrders.unshift(newOrder)
                  }
                });
              }

              this.boostOrders = this.boostOrders.filter(order => {
                const currenciesFilter = Array.isArray(this.currencies)
                  ? this.currencies
                  : []
                const gamesFilter = Array.isArray(this.minimizedFilters?.games)
                  ? this.minimizedFilters.games
                  : []
                const statesFilter = Array.isArray(this.minimizedFilters?.states)
                  ? this.minimizedFilters.states
                  : []

                const finalizedFilter = typeof this.minimizedFilters?.finalized === "boolean"
                  ? this.minimizedFilters.finalized
                  : null

                const currencyMatch = currenciesFilter.length === 0 ? true
                  : currenciesFilter.map(s => s.toLowerCase()).includes(order.currency?.toLowerCase())
                const gameMatch = gamesFilter.length === 0 ? true
                  : gamesFilter.map(s => s.toLowerCase()).includes(order.game.toLowerCase())
                const stateMatch = statesFilter.length === 0 ? true
                  : statesFilter.map(s => s.toLowerCase()).includes(order.state.toLowerCase())

                const finalizedMatch = finalizedFilter === null ? true : order.finalized === finalizedFilter

                return currencyMatch & gameMatch & stateMatch & finalizedMatch
              })

              const latest = response.data.boostOrder?.lastUpdate

              if (latest && !this.isImmediateRequest) {
                this.filters.lastUpdate = latest;
              }
            },
            (errorMessage) => {
              //console.log('⚠️ Handle Credential Expired:', errorMessage);
              return errorMessage;
            },
            (errorMessage) => {
              //console.log('❌ Handle Failure:', errorMessage);
              return errorMessage;
            }
          );
        } catch (e) {

        } finally {
          this.isFetching = false
          if (!this.isImmediateRequest) {
            this.isLoading = false
          }
        }
      }
    },
    /*async action_getSubOrders() {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 10092,
        "boostOrder": this.minimizedFilters,
      };

      if (this.boostOrders.length === 0) {
        this.isLoading = true
      }

      if (this.isFetching === false) {
        try {
          this.isFetching = true
          await useApi(
            request,
            (response) => {
              const newOrders = response.data.boostOrders || []
              if (this.boostOrders.length === 0) {
                this.boostOrders = newOrders;
              } else {
                newOrders.forEach(newOrder => {
                  const index = this.boostOrders.findIndex(
                    o => o.uuid === newOrder.uuid || o.id === newOrder.id
                  );
                  if (index !== -1) {
                    this.boostOrders[index] = newOrder;
                  } else {
                    this.boostOrders.unshift(newOrder)
                  }
                });
              }

              this.boostOrders = this.boostOrders.filter(order => {
                const currenciesFilter = Array.isArray(this.currencies)
                  ? this.currencies
                  : []
                const gamesFilter = Array.isArray(this.minimizedFilters?.games)
                  ? this.minimizedFilters.games
                  : []
                const statesFilter = Array.isArray(this.minimizedFilters?.states)
                  ? this.minimizedFilters.states
                  : []

                const finalizedFilter = typeof this.minimizedFilters?.finalized === "boolean"
                  ? this.minimizedFilters.finalized
                  : null

                const currencyMatch = currenciesFilter.length === 0 ? true
                  : currenciesFilter.map(s => s.toLowerCase()).includes(order.currency?.toLowerCase())
                const gameMatch = gamesFilter.length === 0 ? true
                  : gamesFilter.map(s => s.toLowerCase()).includes(order.game.toLowerCase())
                const stateMatch = statesFilter.length === 0 ? true
                  : statesFilter.map(s => s.toLowerCase()).includes(order.state.toLowerCase())

                const finalizedMatch = finalizedFilter === null ? true : order.finalized === finalizedFilter

                return currencyMatch & gameMatch & stateMatch & finalizedMatch
              })

              const latest = response.data.boostOrder?.lastUpdate

              if (latest) {
                this.filters.lastUpdate = latest;
              }
            },
            (errorMessage) => {
              //console.log('⚠️ Handle Credential Expired:', errorMessage);
              return errorMessage;
            },
            (errorMessage) => {
              //console.log('❌ Handle Failure:', errorMessage);
              return errorMessage;
            }
          );
        } catch (e) {

        } finally {
          this.isFetching = false
          this.isLoading = false
        }
      }
    },*/
    resetLastUpdate() {
      this.filters.lastUpdate = null
    },
    resetFilters() {
      this.currencies = [];
      this.filters = {
        'finalized': this.filters.finalized,
        'stores': [],
        'games': [],
        'states': [],
        'createdFrom': null,
        'createdTo': null,
        'updatedFrom': null,
        'updatedTo': null,
        'lastUpdate': null
      };
    }
  },
  persist: {
    paths: [''],
  },
})
